import { all, takeLatest } from 'redux-saga/effects';
import { GET_ALL_REPORTS, GENERATE_REPORT } from '../../actions/reports';
import { generateReportSaga, getAllReportsSaga } from './getReportsSagas';

function* reportsSagas() {
  yield all([
    yield takeLatest(GET_ALL_REPORTS.INITIATE, getAllReportsSaga),
    yield takeLatest(GENERATE_REPORT.INITIATE, generateReportSaga),
  ]);
}

export default reportsSagas;
